import { createAction } from "@reduxjs/toolkit";
import { ucEndpoints } from "../../config/config";
import { AppDispatch } from "../../reducers";
import { getRegionMetadataSuccess } from "../../store/regionMetadata";
import {
  getRegionSettingsFailure,
  getRegionSettingsSuccess,
  startGetRegionSettings
} from "../../store/regionSettings";
import { apiCallBegan } from "../middlwares/api";
import * as actionTypes from "./actionTypes";

export const getRegionSettings = () => (dispatch: AppDispatch) => {
  dispatch(
    apiCallBegan({
      url: `${ucEndpoints.selectedRegionSettingsPerOrganization}`,
      method: "get",
      onStart: startGetRegionSettings,
      onSuccess: (res: any) => (dispatch: AppDispatch) => {
        const {
          settings,
          metadata,
          baseYear,
          centroid,
          limits,
          modelType,
          modules,
          mpoId,
          name,
          organizationId,
          srs,
          subscription,
          zoom
        } = res;

        //TODO(ngoldenberg): This fix is meant to be removed once the API can finally refactor
        // remaining region metadata fields to its "metadata" inner object
        const mergedSettings = {
          ...settings,
          ...{
            baseYear,
            centroid,
            limits,
            modelType,
            modules,
            mpoId,
            name,
            organizationId,
            srs,
            subscription,
            zoom
          }
        };

        dispatch(getRegionSettingsSuccess(mergedSettings));
        dispatch(getRegionMetadataSuccess(metadata));
      },
      onFailure: getRegionSettingsFailure
    })
  );
};

export const startUpdateRegionSettings = createAction(actionTypes.START_UPDATE_REGION_SETTINGS);

export const updateRegionSettingsSuccess = createAction(actionTypes.UPDATE_REGION_SETTINGS_SUCCESS);

export const updateRegionSettingsFailure = createAction(actionTypes.UPDATE_REGION_SETTINGS_FAILED);

export const updateRegionSettings = (values: any) => (dispatch: AppDispatch) =>
  dispatch(
    apiCallBegan({
      url: `${ucEndpoints.selectedRegionSettingsPerOrganizationUpdate}`,
      method: "put",
      data: values,
      onStart: startUpdateRegionSettings,
      onSuccess: () => (dispatch: AppDispatch) => {
        dispatch(updateRegionSettingsSuccess());
        dispatch(getRegionSettings());
      },
      onSuccessMessage: "Region settings successfully saved!",
      onFailureMessage: "An error occurred while saving region settings",
      onFailure: getRegionSettingsFailure
    })
  );
